/* Service for getting/setting the session */
angular.module('bmsApp.user')
	.service('Session', [
		'$window',
		function ($window) {
			this.setCredentials = function (userInfo) {
				$window.localStorage["userInfo"] = JSON.stringify(userInfo);
			};
			this.getCredentials = function () {
				return JSON.parse($window.localStorage["userInfo"]);
			};
			this.destroy = function () {
				$window.localStorage["userInfo"] = null;
			};
			
			this.setLastState = function (lastState, toParams) {
				$window.sessionStorage["lastState"] = lastState;
				$window.sessionStorage["toParams"] = JSON.stringify(toParams);
			};
			this.getLastState = function () {
				return $window.sessionStorage["lastState"];
			};
			this.getLastToParams = function () {
				return JSON.parse($window.sessionStorage['toParams']);
			}
		}
	]);
